import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "photo-template" }
const _hoisted_2 = ["src", "title"]

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPaging,
  DxStateStoring,
  DxHeaderFilter, 
  DxPager,
  DxButton,
  DxSelection
} from "devextreme-vue/data-grid";
import { UserApprovalModel } from "@/services/entities/Approval/UserApprovalModel"
import { onBeforeMount, ref } from "vue";
import { useAzureStore } from "@/stores/azure";
import { configureDataGridColumnsOrder } from "@/common/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserTable',
  props: {
  data: { Type: {} as UserApprovalModel, default: {} as UserApprovalModel }
},
  emits: ["detail", "selection"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const selectedKeys = ref([] as number[]);
const azureStore = useAzureStore();
let isConfigured = false;

function  onContentReady(e: any) {
  // ensure default column order
  const defaultOrder = ['userItem.id', 'userItem.fullName', 'approvalStatus.name', 'userItem.teamLeader.fullName', 'buttons'];    
  if (!isConfigured) {
    configureDataGridColumnsOrder(e, defaultOrder);
    isConfigured = true;
  }   
};

onBeforeMount(async () => {
  if (props.data.approvalUsers && props.data.approvalUsers.length > 0) {
    await azureStore.loadUserPhotos(props.data.approvalUsers.map((a) => a.userItem.teamLeaderId));
    props.data.approvalUsers.forEach((a: any) => {
      a.photo = azureStore.getUsersPhotos.find((p: any) => p.id === a.userItem.teamLeaderId)?.blob;
    });
  }
});


function selection(e: any){
  emit("selection", e.selectedRowsData);
}

const createBlobUrl = (data: any) => {
  try {
    if (data.userItem.teamLeaderId) {
      const photo = azureStore.getUsersPhotos.find((p: any) => p.id === data.userItem.teamLeaderId)?.blob;
      if (photo) {
        return URL.createObjectURL(photo);
      }
    }
  } catch (e) {
    console.error("Error creating blob URL", e);
    return null;
  }
};

const props = __props;

function showDetail(e: any) {
  selectedKeys.value = [e.row.data.userItem.id];
  emit("detail", e.row.data.userItem);
}

function getApprovalStatusName(data: any): string {
  return data.monthlyApprovalItem?.isLocked ? "Locked" : data.approvalStatus.name;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data.approvalUsers,
    id: "userApprovalGridContainer",
    reduce: (item) => item.userItem,
    "selected-row-keys": selectedKeys.value,
    onSelectionChanged: selection,
    "auto-navigate-to-focused-row": true,
    "key-expr": "userItem.id",
    onContentReady: onContentReady
  }, {
    "grid-cell-template": _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: createBlobUrl(data.data),
          alt: "Direct manager",
          class: "person-photo person-photo--rounded",
          title: data.data.userItem.teamLeader?.fullName
        }, null, 8, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "userApprovalGridContainer"
      }),
      _createVNode(_unref(DxSelection), {
        "select-all-mode": "allPages",
        "show-check-boxes-mode": "always",
        mode: "multiple",
        width: 30
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "userItem.id",
        "data-type": "string",
        caption: "Id",
        visible: false
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "userItem.fullName",
        "data-type": "string",
        caption: "Name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "approvalStatus.name",
        "data-type": "string",
        caption: "State",
        "calculate-cell-value": getApprovalStatusName,
        width: 125
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "userItem.teamLeader.fullName",
        caption: "TL",
        width: 50,
        "cell-template": "grid-cell-template"
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 60
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "View detail",
            icon: "eyeopen",
            "styling-mode": "contained",
            type: "normal",
            onClick: showDetail
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "reduce", "selected-row-keys"]))
}
}

})